<app-sip-top-banner></app-sip-top-banner>

<app-offer-card *ngIf="param.st !== 'f' && showOffer && userData && !userData?.listsubscriptions?.medical && currencyInfo==='INR' && !actRoute?.snapshot?.queryParams?.offer" [config]="{offerAmount: 100, currency: 'INR'}"></app-offer-card>

<div *ngIf="config?.sipPitch" (click)="knowMore()" class="sip-banner-1">
  <app-sip-top-banner-v2></app-sip-top-banner-v2>
</div>

<div class="main-wrapper-v2">
  <div class="title">{{updates?.data[0]?.updatable?.title || variablesService?.fundraiser?.title}}</div>
  <app-timeline-v2 *ngIf="userData && !userData?.listsubscriptions?.medical && param?.is_donor>=0" [userData]="userData" [fundraiser]="updatesSummary?.data"></app-timeline-v2>
  <div class="banner">
    <app-update-banner></app-update-banner>
    <div class="d-flex align-items-center align-content-between white-bg">
      <div class="full-width">
        <app-update-summary class="update-summary-component" [currencyIcon]="currencyIcon" [currency]="currencyInfo"
                            [summaryDetails]="updatesSummary?.data">
        </app-update-summary>
      </div>
      <div class="d-flex share">
        <div class="fb-share-component">
          <app-fb-share *ngIf="campaign_url" [label]="!isMobile ? 'Share': ''" [buttonType]="isMobile ? 'round': 'square'" [fundraiser]="updatesSummary?.data"
                        [count]="sharedCounts.fb" [campaign_url]="campaign_url" [utm_params]="utm_params"
                        class="fb-share-component">
          </app-fb-share>
        </div>
        <div class="whatsapp-share-component">
          <app-whatsapp-share *ngIf="updatesSummary" [basicInfo]="basicInfo" [fundraiser]="updatesSummary?.data"
                              [isFundraiserEnded]="isFundraiserEnded" [label]="!isMobile ? 'Share': ''"
                              [customTag]="updatesSummary?.data?.custom_tag" [count]="sharedCounts">
          </app-whatsapp-share>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!checkLatestUpdate(updates?.data[0]?.id, latestUpdate?.data[0]?.id)" class="view-latest-update">
    <div class="title">There are recent updates available</div>
    <div (click)="getFundraiserUpdates(param?.fmd_id, latestUpdate?.data[0]?.id, 'INR');" class="link">View Latest Update</div>
  </div>
  <div id="update-section" class="update-component">
    <app-update *ngIf="updates.data.length" [updates]="updates" [latestUpdate]="latestUpdate?.data[0]?.id"
                [pageName]="'updatesPage'" [viewMore]="updates?.next_page_url ? true : false"
                [customTag]="updatesSummary?.data?.custom_tag" [urlParams]="param" [showImpactCard]="true"
                [basicInfo]="basicInfo" [fundraiser]="updatesSummary?.data" [isFundraiserEnded]="isFundraiserEnded"
                [updateReact]="updateReact" (viewMoreUpdates)="viewMoreUpdates($event)" (commentPosted)="commentPosted($event)"
                (CommentVisible)="CommentVisible($event)" [showSocialShare]="true" class="update-boxes" (monthlyCardVisible)="docker.visible=$event.visible"
                [isDonated]="docker.isDonated" [showComments]="false" [currency]="currencyInfo" [showMoreBtn]="true"
                [config]="config">
    </app-update>
  </div>
</div>

<!-- Similar fundraiser -->
<div [ngClass]="{'outer-wrapper': !isMobile}">
  <app-similar-fundraiser class="similar-fr" [fundraisers]="similarFundraisers" [slidesPerView]="4"
    title="People like you contributed to these Fundraisers" [amount]="false" [supporters]="false">
  </app-similar-fundraiser>
</div>

<app-chat-with-us [html]="'Some fundraisers are not eligible for tax deduction such as 80G, 501(c), etc. Any Questions? '" [hidden]="isMobile"></app-chat-with-us>

<!-- Onetim/Sip payment bottom dock -->
<app-impact-docker class="d-lg-block d-md-block"
                  *ngIf="variablesService?.fundraiser && !docker?.visible && (config.allowOneTimeDonation || config.sipPitch)"
                  elementId="donation-form" [icon]="false"
                  [btnLabel]="!config.allowOneTimeDonation ? 'Start Monthly Giving':'Contribute Now'"
                  [text]="!config.allowOneTimeDonation ? 'Continue Doing Good' : variablesService?.fundraiser?.campaigner?.full_name+' needs your support'"
                  [updateId]="param?.update_id" [top]="30" [isDonated]="!config.allowOneTimeDonation">
</app-impact-docker>


<!-- Similar fundraiser Popup -->
<ng-template #similarFundraiser>
  <div class="dialog">
    <div class="dialog-header">
      <button (click)="dialog.closeAll()" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="dialog-title"><span>Here is a similar fundraiser that needs your help right now</span></div>
    <div class="dialog-content" matDialogContent>
      <app-similar-fundraiser [fundraisers]="similarFundraisers" title="Trending Fundraiser"
        [amount]="false" [supporters]="false" [slidesPerView]="3.2" [config]="{sysEventOnClick: true}">
      </app-similar-fundraiser>
    </div>
  </div>
</ng-template>

<!-- payment module -->
<app-main-payment class="d-none" *ngIf="param?.type === 'onetime' && param.st === 'f' && variablesService?.fundraiser && !isFundraiserEnded" [internal]="true" [fundraiser]="variablesService?.fundraiser" origin="up" type="onpage"></app-main-payment>

<!-- Sip Tickr -->
<app-sip-ticker *ngIf="config.sipPitch"></app-sip-ticker>

